// src/kendintasarla/NeonCanvas.js
import React, { useState, useEffect, useRef } from "react";
import { Tab, Tabs, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./neonstyle.css";// Assuming you have a CSS file for styles

const NeonCanvas = () => {
  const [text, setText] = useState("Kendin Tasarla!");
  const [fontSize] = useState(60); // Removed setFontSize since it's not used
  const [color, setColor] = useState("rgb(255, 255, 255)");
  const [bgImage, setBgImage] = useState("/resimler/kendintasarla/bg1.jpg");
  const [fontFamily, setFontFamily] = useState("Dancing Script");
  const [position, setPosition] = useState({ x: 0, y: 50 });
  const [isDragging, setIsDragging] = useState(false);
  const [isNeonOn, setIsNeonOn] = useState(true);
  const canvasRef = useRef(null);
  const textRef = useRef(null);
  const hiddenCanvasRef = useRef(null);

  useEffect(() => {
    const centerTextHorizontally = () => {
      if (canvasRef.current && textRef.current) {
        const canvasWidth = canvasRef.current.offsetWidth;
        const textWidth = textRef.current.offsetWidth;
        setPosition((prev) => ({
          ...prev,
          x: (canvasWidth - textWidth) / 2,
        }));
      }
    };

    centerTextHorizontally();
    window.addEventListener("resize", centerTextHorizontally);
    return () => window.removeEventListener("resize", centerTextHorizontally);
  }, [fontSize, text, fontFamily]);

  const handleTextChange = (e) => setText(e.target.value);
  const handleBgChange = (bg) => setBgImage(bg);
  const handleFontChange = (font) => setFontFamily(font);
  const handleSymbolAdd = (symbol) => setText((prev) => prev + symbol);
  const handleMouseMove = (e) => {
    if (isDragging) {
      const canvas = canvasRef.current;
      const rect = canvas.getBoundingClientRect();
      setPosition({
        x: e.clientX - rect.left - textRef.current.offsetWidth / 2,
        y: e.clientY - rect.top - textRef.current.offsetHeight / 2,
      });
    }
  };

  const handleDownloadClick = async () => {
    try {
      const canvasElement = canvasRef.current;
      const hiddenCanvas = hiddenCanvasRef.current;
      const ctx = hiddenCanvas.getContext("2d");

      hiddenCanvas.width = canvasElement.offsetWidth;
      hiddenCanvas.height = canvasElement.offsetHeight;

      await document.fonts.ready;

      const bgImg = new Image();
      bgImg.crossOrigin = "Anonymous";
      bgImg.src = bgImage;

      await new Promise((resolve) => {
        bgImg.onload = resolve;
      });

      ctx.drawImage(bgImg, 0, 0, hiddenCanvas.width, hiddenCanvas.height);

      ctx.font = `${fontSize}px ${fontFamily}`;
      ctx.fillStyle = "rgb(255, 255, 255)";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      const textX = position.x + textRef.current.offsetWidth / 2;
      const textY = position.y + textRef.current.offsetHeight / 2;

      if (isNeonOn) {
        ctx.shadowColor = color;
        ctx.shadowBlur = 20;
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 0;
      } else {
        ctx.shadowBlur = 0;
      }

      ctx.fillText(text, textX, textY);

      const link = document.createElement("a");
      link.href = hiddenCanvas.toDataURL("image/png"); // Removed unused dataUrl variable
      link.download = "neon-tasarim.png";
      link.click();
    } catch (error) {
      console.error("Error generating canvas image for download:", error);
      alert("Tasarım indirilirken bir hata oluştu. Lütfen tekrar deneyin.");
    }
  };

  const handleWhatsAppClick = async () => {
    try {
      const canvasElement = canvasRef.current;
      const hiddenCanvas = hiddenCanvasRef.current;
      const ctx = hiddenCanvas.getContext("2d");

      hiddenCanvas.width = canvasElement.offsetWidth;
      hiddenCanvas.height = canvasElement.offsetHeight;

      await document.fonts.ready;

      const bgImg = new Image();
      bgImg.crossOrigin = "Anonymous";
      bgImg.src = bgImage;

      await new Promise((resolve) => {
        bgImg.onload = resolve;
      });

      ctx.drawImage(bgImg, 0, 0, hiddenCanvas.width, hiddenCanvas.height);

      ctx.font = `${fontSize}px ${fontFamily}`;
      ctx.fillStyle = "rgb(255, 255, 255)";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      const textX = position.x + textRef.current.offsetWidth / 2;
      const textY = position.y + textRef.current.offsetHeight / 2;

      if (isNeonOn) {
        ctx.shadowColor = color;
        ctx.shadowBlur = 20;
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 0;
      } else {
        ctx.shadowBlur = 0;
      }

      ctx.fillText(text, textX, textY);

      const whatsappMessage = `Metin: ${text}\nFont: ${fontFamily}\nRenk: ${color}\nTasarım Görseli:\n(Lütfen bu mesajı gönderdikten sonra tasarım görselini WhatsApp üzerinden manuel olarak paylaşın)`;
      const phoneNumber = "+905524543679";
      const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(whatsappMessage)}`;

      window.open(url, "_blank");
    } catch (error) {
      console.error("Error generating canvas image for WhatsApp:", error);
      const message = `Metin: ${text}\nFont: ${fontFamily}\nRenk: ${color}\n(Görsel oluşturulamadı, lütfen tasarımı tarif edin)`;
      const phoneNumber = "+905524543679";
      const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
      window.open(url, "_blank");
    }
  };

  const backgrounds = [
    "/resimler/kendintasarla/bg1.jpg",
    "/resimler/kendintasarla/bg2.jpg",
    "/resimler/kendintasarla/bg3.jpg",
    "/resimler/kendintasarla/bg4.jpg",
    "/resimler/kendintasarla/bg5.jpg",
  ];

  const fonts = [
    "Dancing Script",
    "Caveat",
    "Shadows Into Light",
    "Indie Flower",
    "Amatic SC",
    "Permanent Marker",
    "Architects Daughter",
    "Gloria Hallelujah",
    "Satisfy",
    "Patrick Hand",
    "Covered By Your Grace",
    "Reenie Beanie",
    "Sue Ellen Francisco",
    "Homemade Apple",
    "Rock Salt",
    "Nothing You Could Do",
    "Just Me Again Down Here",
  ];

  const neonColors = [
    { name: "Beyaz", value: "rgb(255, 255, 255)" },
    { name: "Gün Işığı", value: "rgb(255, 221, 87)" },
    { name: "Limon Sarı", value: "rgb(255, 255, 102)" },
    { name: "Amber", value: "rgb(255, 191, 0)" },
    { name: "Turuncu", value: "rgb(255, 127, 80)" },
    { name: "Kırmızı", value: "rgb(205, 46, 31)" },
    { name: "Pembe", value: "rgb(255, 105, 180)" },
    { name: "Mor", value: "rgb(155, 89, 182)" },
    { name: "Parlement Mavi", value: "rgb(52, 152, 219)" },
    { name: "Buz Mavisi", value: "rgb(26, 188, 156)" },
    { name: "Yeşil", value: "rgb(46, 204, 113)" },
  ];

  const symbols = [
    { name: "Kalp", value: "♥" },
    { name: "Yıldız", value: "★" },
    { name: "Ok", value: "→" },
    { name: "Çiçek", value: "✿" },
    { name: "Güneş", value: "☀" },
    { name: "Ay", value: "☾" },
    { name: "Yıldırım", value: "⚡" },
    { name: "Not", value: "♪" },
    { name: "Elmas", value: "◆" },
    { name: "Kare", value: "■" },
    { name: "Üçgen", value: "▲" },
    { name: "Daire", value: "●" },
  ];

  return (
    <div className="main-container">
      <div className="headarc">
        <h1 className="title">
          Yadi Baskı ile Kendi Neonunu Oluştur
        </h1>
      </div>

      <div className="content-wrapper">
        <Card className="control-panel shadow-lg rounded-4">
          <Tabs defaultActiveKey="text" className="custom-tabs">
            <Tab eventKey="text" title="YAZI" className="tab-content">
              <textarea
                className="form-control text-input"
                rows={4}
                value={text}
                onChange={handleTextChange}
                placeholder="Buraya Yazın! Yeni satıra geçmek için Enter'a tıklayın."
              />
            </Tab>
            <Tab eventKey="font" title="FONT" className="tab-content">
              <h5 className="section-title">FONT SEÇ</h5>
              <div className="font-grid">
                {fonts.map((font, index) => (
                  <div
                    key={index}
                    onClick={() => handleFontChange(font)}
                    className={`font-option ${fontFamily === font ? 'active' : ''}`}
                    style={{ fontFamily: font }}
                  >
                    {font}
                  </div>
                ))}
              </div>
            </Tab>
            <Tab eventKey="color" title="RENK" className="tab-content">
              <h5 className="section-title">RENK SEÇ</h5>
              <div className="color-grid">
                {neonColors.map((colorOption, index) => (
                  <div key={index} className="color-option">
                    <div
                      className={`color-circle ${color === colorOption.value ? 'active' : ''}`}
                      style={{ backgroundColor: colorOption.value }}
                      onClick={() => setColor(colorOption.value)}
                    />
                    <span className="color-name">{colorOption.name}</span>
                  </div>
                ))}
              </div>
              <div
                className="color-gradient"
                onClick={(e) => {
                  const rect = e.target.getBoundingClientRect();
                  const x = e.clientX - rect.left;
                  const ratio = x / rect.width;
                  const colors = [
                    "rgb(255, 0, 0)",
                    "rgb(255, 165, 0)",
                    "rgb(255, 255, 0)",
                    "rgb(0, 255, 0)",
                    "rgb(0, 255, 255)",
                    "rgb(0, 0, 255)",
                    "rgb(238, 130, 238)",
                    "rgb(255, 192, 203)",
                    "rgb(255, 255, 255)",
                  ];
                  const index = Math.floor(ratio * (colors.length - 1));
                  setColor(colors[index]);
                }}
              />
            </Tab>
            <Tab eventKey="symbols" title="SEMBOLLER" className="tab-content">
              <h5 className="section-title">SEMBOL EKLE</h5>
              <div className="symbol-grid">
                {symbols.map((symbol, index) => (
                  <div
                    key={index}
                    onClick={() => handleSymbolAdd(symbol.value)}
                    className="symbol-option"
                  >
                    {symbol.value}
                    <div className="symbol-name">{symbol.name}</div>
                  </div>
                ))}
              </div>
            </Tab>
          </Tabs>

          <div className="background-section">
            <h5 className="section-title">Arkaplan</h5>
            <div className="background-images">
              {backgrounds.map((bg, index) => (
                <img
                  key={index}
                  src={bg}
                  alt={`bg-${index}`}
                  className={`background-option ${bgImage === bg ? 'active' : ''}`}
                  onClick={() => handleBgChange(bg)}
                />
              ))}
            </div>
          </div>

          <p className="info-text">
            Tasarımına karar verdiğiniz ürünün fiyatını öğrenmek için WhatsApp üzerinden bizimle iletişime geçebilirsiniz.
          </p>

          <div className="button-group">
            <button className="whatsapp-btn" onClick={handleWhatsAppClick}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-whatsapp"
                viewBox="0 0 16 16"
              >
                <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
              </svg>
              WHATSAPP İLE İLETİŞİME GEÇ
            </button>

            <button className="download-btn" onClick={handleDownloadClick}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-download"
                viewBox="0 0 16 16"
              >
                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
              </svg>
              TASARIMI İNDİR
            </button>
          </div>
        </Card>

        <div
          ref={canvasRef}
          className="canvas-container"
          style={{ backgroundImage: `url(${bgImage})` }}
          onMouseMove={handleMouseMove}
          onMouseUp={() => setIsDragging(false)}
          onMouseDown={(e) => {
            setIsDragging(true);
            e.preventDefault();
          }}
        >
          <div className="neon-toggle">
            <button
              onClick={() => setIsNeonOn(true)}
              className={isNeonOn ? 'active' : ''}
            >
              ON
            </button>
            <button
              onClick={() => setIsNeonOn(false)}
              className={!isNeonOn ? 'active' : ''}
            >
              OFF
            </button>
          </div>

          <h1
            ref={textRef}
            className={`neon-text ${isDragging ? 'grabbing' : 'grab'}`}
            style={{
              top: `${position.y}px`,
              left: `${position.x}px`,
              fontFamily: fontFamily,
              textShadow: isNeonOn
                ? `
                  rgb(255, 255, 255) 0px 0px 2px,
                  ${color} 0px 0px 10px,
                  ${color} 0px 0px 20px,
                  ${color} 0px 0px 30px,
                  ${color} 0px 0px 40px,
                  ${color} 0px 0px 50px
                `
                : 'none'
            }}
          >
            {text}
          </h1>
        </div>
      </div>

      <canvas ref={hiddenCanvasRef} className="hidden-canvas" />
      <div className="powered-by-section">
  <p>
    Powered by <a href="https://hacialikara.com" target="_blank" rel="noopener noreferrer">H.Ali.K.</a>
  </p>
</div>
    </div>
  );
};

export default NeonCanvas;